import { Dayjs } from "dayjs";
import { generateReservationListReport } from "../../utilities/completeReservationReportGeneration";
import getReservationListReport from "../../utilities/getReservationListReport";
import { generateTotalCheckMatchReportByDateGeneration } from "../../utilities/completeTotalCheckMatchReportByDateGeneration";
import getCheckMatchReport from "../../utilities/getCheckMatchReport";
import { generateCheckMatchReportGeneration } from "../../utilities/completeCheckMatchReportGeneration";
import getTotalCheckMatchReportByDate from "../../utilities/getTotalCheckMatchReportByDate";
import { NotificationProps } from "../../context/NotificationsContext";
import { ApiClientProps } from "../../hooks/useApi";
import type { notify } from "../../context/NotificationsContext";


interface Deps {
    start: Dayjs;
    end: Dayjs;
    partnerVenueIds: string[];
    accessToken: string;
    apiClient: any;
    notify: notify
}
export type ReportType =
    | "reservation"
    | "checkmatch"
    | "checkmatch_total";
const API_DATE = "YYYY-MM-DD[T]HH:mm:ss";
const asRange = (start: Dayjs, end: Dayjs) => ({
  from: start.startOf("day").format(API_DATE),
  to: end.endOf("day").format(API_DATE),
});
export async function generateReservationListReportHandler(
  deps: Deps
): Promise<Blob | undefined> {
    const { start, end, partnerVenueIds, accessToken, apiClient, notify } = deps;
    const reportResponse = await generateReservationListReport({
      ...asRange(start, end),
      partnerVenueIds,
      accessToken,
      apiClient,
    });
    const requestId: string = reportResponse.resource.requestId;
    return await getReservationListReport({
      requestId,
      format: "csv",
      accessToken,
      apiClient,
      notify
    });
}
export async function generateCheckMatchReportHandler(
  deps: Deps
): Promise<Blob | undefined> {
    const { start, end, partnerVenueIds, accessToken, apiClient, notify } = deps;
    const reportResponse = await generateCheckMatchReportGeneration({
      ...asRange(start, end),
      partnerVenueIds,
      accessToken,
      apiClient,
    });
    const requestId: string = reportResponse.resource.requestId;
    return await getCheckMatchReport({
      requestId,
      format: "csv",
      accessToken,
      apiClient,
      notify
    });
}

export async function generateTotalCheckMatchReportHandler(
  deps: Deps
): Promise<Blob | undefined> {
    const { start, end, partnerVenueIds, accessToken, apiClient, notify } = deps;
    const reportResponse = await generateTotalCheckMatchReportByDateGeneration({
      ...asRange(start, end),
      partnerVenueIds,
      accessToken,
      apiClient,
    });
    const requestId: string = reportResponse.resource.requestId;
    return await getTotalCheckMatchReportByDate({
      requestId,
      format: "csv",
      accessToken,
      apiClient,
      notify
    });
}

export async function generateReport(
  reportType: ReportType,
  deps: {
        start: any;
        end: any;
        partnerVenueIds: any;
        accessToken: string;
        apiClient: ApiClientProps;
        notify: (notification: NotificationProps) => void
    }
): Promise<Blob | undefined> {


    switch (reportType) {
    case "reservation":
      return await generateReservationListReportHandler(deps);
    case "checkmatch":
      return await generateCheckMatchReportHandler(deps);
    case "checkmatch_total":
      return await generateTotalCheckMatchReportHandler(deps);
    default: {
        // Exhaustive guard for future types
        const _never: never = reportType;
        throw new Error(`Unsupported report type: ${_never}`);
    }
    }
}

